module.exports = __webpack_public_path__ + "static/media/b7489e1d-53c6-414e-a325-5adf8e204b8d.f8929088.woff2";